
export default function ConfirmationModal ({modalId, headerText, messageText, confirmButtonText, Action, danger=false}) {

  function ParagraphText({text}){
    return(
      <p className="m-4 fs-5 text-center"  style={{'fontWeight': '500'}}>{text}</p>    
    );
  }

  let rows = [];
  for (let i in messageText) {
    rows.push(
      <ParagraphText 
        key={i} 
        text={messageText[i]}
      />
    );
  }

  return(
    <div 
        className="modal fade modal-xs" 
        id={modalId} 
        tabIndex="-1" 
        aria-labelledby={modalId + "Label"} 
        aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable modal-xs">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h2 className="modal-title fs-5" id={modalId + "Label"}>{headerText}</h2>
            <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {rows}
          </div>
          <div className="modal-footer justify-content-between">
            <button 
              type="button" 
              className="btn btn-secondary lk-bootstrap-button" 
              data-bs-dismiss="modal">
              Отмена
            </button>

            {danger === true?
              <button 
                type="button" 
                className="btn btn-danger lk-bootstrap-button" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={() => Action()}
              >
                {confirmButtonText}
              </button>
            :
              <button 
                type="button" 
                className="btn lk-button lk-bootstrap-button" 
                data-bs-dismiss="modal" 
                aria-label="Close" 
                onClick={() => Action()}
              >
                {confirmButtonText}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
}